// src/components/ui/GlassPanel.jsx
"use client";

import { cn } from "../../lib/utils";

export default function GlassPanel({ children, className = "" }) {
  return (
    <div
      className={cn(
        "relative overflow-hidden rounded-[32px]",
        "border border-white/15",
        "backdrop-blur-[20px]",
        "bg-[linear-gradient(180deg,rgba(46,51,90,0)_0%,rgba(28,27,51,0.1)_100%)]",
        "shadow-[0_30px_60px_0px_rgba(0,0,0,0.1),0_15px_30px_0px_rgba(0,0,0,0.05),0_5px_10px_0px_rgba(0,0,0,0.05),inset_0_0_100px_0px_rgba(204,215,255,0.15)]",
        className
      )}
    >
      {/** Patrón de puntitos más suaves **/}
      <div
        className="pointer-events-none absolute inset-0 rounded-[inherit]"
        style={{
          backgroundImage:
            "repeating-radial-gradient(circle, rgba(255,255,255,0.05) 0px, rgba(255,255,255,0.05) 0.5px, transparent 0.5px, transparent 12px)",
          backgroundSize: "15px 15px",
        }}
      />

      {/** Vignette en bordes **/}
      <div
        className="pointer-events-none absolute inset-0 rounded-[inherit]"
        style={{
          background:
            "radial-gradient(circle at center, transparent 60%, rgba(255,255,255,0.08) 100%)",
        }}
      />

      {/** Contenido **/}
      <div className="relative z-10">{children}</div>
    </div>
  );
}
